export enum TaskStatusActions {
  Start = 'start',
  Hide = 'hide',
  Pause = 'pause',
  Cancel = 'cancel',
  Complete = 'complete',
  Release = 'release',
  OnHold = 'onHold',
}
